import { PropsWithChildren, JSX } from 'react';
import { IconWrapper } from '@bg-components/Icon';
import classes from './LabelPlate.module.scss';
import { ReactComponent as PlateBlack } from './images/plate-black.svg';
import { ReactComponent as PlateRed } from './images/plate-red.svg';

interface IProps {
    label: string;
    red: boolean;
}

export const LabelPlate = (props: PropsWithChildren<IProps>): JSX.Element => (
    <div className={classes.container}>
        <div className={classes.labelWrapper}>
            <IconWrapper component={props.red ? PlateRed : PlateBlack} />
            <div className={classes.label}>{props.label}</div>
        </div>
        {props.children}
    </div>
);
